<template>
  <div class="hr-autopilot-employees px-6 sm:px-8 pt-16">
    <SectionHeader class="max-w-3xl mx-auto px-0 lg:px-12">
      <template #header>
        <div class="text-left md:text-center mb-4">
          HR Autopilot Creates Professional Workplaces
          <span class="text-primary-tint-3">for&nbsp;Employees</span>
        </div>
      </template>
      <template #subheader>
        <div class="text-left md:text-center">
          Studies show that employees thrive with the right HR practices in
          place. This benefits you, your employees, and your business. Bambee’s
          HR Autopilot is already benefiting over 100,000 American employees.
        </div>
      </template>
    </SectionHeader>
    <div class="autopilot-grid flex flex-col md:flex-row justify-center py-11">
      <div class="left-block flex justify-center px-0 md:px-4 lg:px-12">
        <div class="wrapped-column w-fit">
          <div
            v-for="(item, index) in leftItems"
            :key="`left-items-${index}`"
            class="wrapped-column-item flex mb-8"
          >
            <ClipboardCheck
              v-if="item.icon === 'clipboardCheck'"
              class="icon flex flex-shrink-0 object-top h-12 w-12 mr-6"
            />

            <PostItCheck
              v-else-if="item.icon === 'postitCheck'"
              class="icon flex flex-shrink-0 object-top h-12 w-12 mr-6"
            />

            <div class="text-block max-w-none md:max-w-xs">
              <TypeBody
                :variant="$options.Typography.Body.MEDIUM"
                :weight="$options.Typography.Weights.STRONG"
              >
                <p class="mb-1">{{ item.title }}</p></TypeBody
              >
              <TypeBody
                :variant="$options.Typography.Body.MEDIUM"
                :weight="$options.Typography.Weights.REGULAR"
              >
                <p class="mb-1">{{ item.body }}</p></TypeBody
              >
            </div>
          </div>
        </div>
      </div>
      <div class="right-block flex justify-center px-0 md:px-4 lg:px-12">
        <div class="wrapped-column w-fit">
          <div
            v-for="(item, index) in rightItems"
            :key="`right-items-${index}`"
            class="wrapped-column-item flex mb-8"
          >
            <Presentation
              v-if="item.icon === 'presentation'"
              class="icon flex flex-shrink-0 object-top h-12 w-12 mr-6"
            />

            <HighlightedIcon
              v-else
              size="large"
              :icon="item.icon"
              class="icon flex flex-shrink-0 object-top h-12 w-12 mr-6"
            />
            <div class="text-block max-w-none md:max-w-xs">
              <TypeBody
                :variant="$options.Typography.Body.MEDIUM"
                :weight="$options.Typography.Weights.STRONG"
                tag="p"
              >
                {{ item.title }}
              </TypeBody>
              <TypeBody
                :variant="$options.Typography.Body.MEDIUM"
                :weight="$options.Typography.Weights.REGULAR"
                tag="p"
              >
                {{ item.body }}
              </TypeBody>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constants, HighlightedIcon, TypeBody } from '@bambeehr/pollen';
import SectionHeader from './SectionHeader';

import { EmployeeAutopilot } from '@/modules/HomePage/constants';
import ClipboardCheck from '~/assets/images/market/icons/hl-icon-clipboard-check.svg';
import PostItCheck from '~/assets/images/market/icons/hl-icon-postit-check.svg';
import Presentation from '~/assets/images/market/icons/hl-icon-presentation.svg';

const { Typography } = constants;
export default {
  name: 'HrAutopilotForEmployees',
  Typography,
  components: {
    ClipboardCheck,
    HighlightedIcon,
    PostItCheck,
    Presentation,
    SectionHeader,
    TypeBody,
  },
  setup() {
    const { leftItems, rightItems } = EmployeeAutopilot;
    return {
      leftItems,
      rightItems,
    };
  },
};
</script>
